module.exports = __webpack_public_path__ + "static/media/maxSuccessionLosses_60_70.bbd63631.png";